var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoteSm = function SvgNoteSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3641",
    fillRule: "evenodd",
    d: "M13,2 C13.5522847,2 14,2.44771525 14,3 L14,11 C14,11.5522847 13.5522847,12 13,12 L11,12 L8,15 L5,12 L3,12 C2.44771525,12 2,11.5522847 2,11 L2,3 C2,2.44771525 2.44771525,2 3,2 L13,2 Z M13,3 L3,3 L3,11 L5.41421356,11 L8,13.5857864 L10.5857864,11 L13,11 L13,3 Z M11,8 L11,9 L5,9 L5,8 L11,8 Z M11,5 L11,6 L5,6 L5,5 L11,5 Z"
  })));
};
export default SvgNoteSm;